import { Locale, translate } from "./translations";

const ru: Locale = {
  welcome: "Добро пожаловать в APAATO",
  signIn: "Войти",
  register: "Регистрация",
  accountType: "Тип аккаунта",
  accountTypeUser: "Пользователь",
  accountTypePartner: "Партнёр",
  firstName: "Имя",
  lastName: "Фамилия",
  orgName: "Название организации",
  createAccount: "Создать аккаунт",
  registrationRequired: "Пожалуйста, завершите регистрацию, чтобы продолжить.",
  signOut: "Выйти",
  greeting: (name: string) => `Привет, ${name}`,
  email: "Эл. почта",
  password: "Пароль",
  continueWithGoogle: "Войти через Google",
  pleaseWait: "Пожалуйста, подождите...",
  fillAllFields: "Пожалуйста, заполните все поля.",
  userNotFound: "Пользователь с таким email не найден.",
  wrongPassword: "Неверный пароль.",
  authFailed: "Ошибка аутентификации. Попробуйте ещё раз.",
  signInCancelled: "Процесс входа был отменён.",
  googleSignInFailed: "Не удалось войти через Google. Попробуйте ещё раз.",
  notAuthorized: "Ваш аккаунт не авторизован для доступа к этой среде.",
  registrationFailed: "Регистрация не удалась. Попробуйте ещё раз.",

  confirmPassword: "Подтвердите пароль",
  accountTypeUserHint: "Хочу найти квартиру в Японии",
  accountTypePartnerHint: "Хочу размещать объявления о жилье",
  show: "Показать",
  hide: "Скрыть",
  emailRequired: "Email обязателен",
  emailInvalid: "Введите корректный email",
  passwordRequired: "Пароль обязателен",
  passwordMin8: "Пароль должен быть не короче 8 символов",
  passwordNeedNumber: "Пароль должен содержать хотя бы одну цифру",
  passwordNeedSymbol: "Пароль должен содержать хотя бы один символ",
  passwordNeedUpper: "Пароль должен содержать хотя бы одну заглавную букву",
  passwordNeedLower: "Пароль должен содержать хотя бы одну строчную букву",

  passwordRequirements: "Требования к паролю",
  passwordReqMin8: "Не менее 8 символов",
  passwordReqNumber: "Хотя бы 1 цифра",
  passwordReqSymbol: "Хотя бы 1 символ",
  passwordReqUpper: "Хотя бы 1 заглавная буква",
  passwordReqLower: "Хотя бы 1 строчная буква",

  notVerified: "Пожалуйста, подтвердите email перед входом.",
  forbidden: "Доступ к этой среде запрещён.",

  confirmPasswordRequired: "Подтвердите пароль",
  passwordsDontMatch: "Пароли не совпадают",
  firstNameRequired: "Имя обязательно",
  lastNameRequired: "Фамилия обязательна",
  orgNameRequired: "Название организации обязательно",

  // Email verification flow
  verificationSentTitle: "Подтвердите email",
  verificationSentBody: (email: string) =>
    `Мы отправили письмо на ${email}. Пожалуйста, проверьте почту и перейдите по ссылке для подтверждения аккаунта.`,
  okGotIt: "Понятно",
  emailConfirmedTitle: "Email подтверждён",
  emailConfirmedBody:
    "Спасибо! Ваш email подтверждён. Теперь вы можете войти в аккаунт.",
  logIntoAccount: "Войти в аккаунт",

  // Verification page
  verificationFailedTitle: "Ошибка подтверждения",
  verificationExpired:
    "Срок действия этой ссылки истёк. Пожалуйста, запросите новую.",
  verificationInvalid: "Эта ссылка недействительна или уже была использована.",
  verificationFailed: "Не удалось подтвердить email. Попробуйте позже.",
  verificationMissingCodeTitle: "Код подтверждения отсутствует",
  verificationMissingCodeBody:
    "Код подтверждения не указан. Пожалуйста, нажмите на ссылку из письма ещё раз.",
  backToLogin: "Вернуться к входу",
  resendVerificationEmail: "Отправить письмо повторно",
  resendVerificationHint: (email: string) =>
    `Отправить новую ссылку для подтверждения на ${email}?`,
  verificationResent: "Письмо отправлено. Проверьте почту.",
  resendFailed: "Не удалось отправить письмо. Попробуйте ещё раз.",

  // Homepage
  dashboard: "Панель управления",
  homeHeroTitle: "Найдите идеальное жильё в Японии",
  homeHeroSubtitle:
    "Качественные квартиры в Токио для иностранцев и местных жителей.",
  searchPrefecture: "Префектура",
  searchSelectPrefecture: "Выберите префектуру",
  searchCity: "Город",
  searchSelectCity: "Выберите город",
  searchLocation: "Район",
  searchSelectArea: "Выберите район",
  searchMoveIn: "Дата заселения",
  searchMoveInPlaceholder: "Выберите дату",
  searchOccupants: "Проживающих",
  searchRentBudget: "Месячный бюджет",
  searchRoomLayout: "Планировка",
  searchPerson: "человек",
  searchPeople: "человек",
  searchButton: "Найти квартиры",
  searchEditCriteria: "Редактировать поиск",
  featureQualityTitle: "Качественное жильё",
  featureQualityDesc: "Каждое объявление проверено на качество и комфорт.",
  featureTrustedTitle: "Надёжные партнёры",
  featureTrustedDesc: "Работаем с проверенными агентствами и арендодателями.",
  featureSupportTitle: "Местная поддержка",
  featureSupportDesc: "Многоязычная команда поможет вам освоиться.",
  disclaimerTitle: "MVP в разработке",
  disclaimerBody:
    "Это ранняя версия MVP. Функция поиска и список объектов появятся скоро. Пока поддерживается только район Токио.",
  footerRights: "Все права защищены.",

  // Philosophy Section
  philosophyTitle: "Наша философия",
  philosophySubtitle:
    "Мы хотим упростить поиск квартиры в Японии для иностранцев.",
  philosophyNoFeesTitle: "Без скрытых платежей",
  philosophyNoFeesDesc:
    "Полная прозрачность цен. То, что вы видите — это то, что вы платите. Никаких сюрпризов.",
  philosophySimpleTitle: "Простой интерфейс",
  philosophySimpleDesc:
    "Чистый и интуитивно понятный дизайн, который делает поиск жилья лёгким.",
  philosophyQualityTitle: "Качественные объявления",
  philosophyQualityDesc:
    "Качественные объявления со всей необходимой информацией о недвижимости и квартирах.",
  philosophyVerifiedTitle: "Проверенные риелторы",
  philosophyVerifiedDesc:
    "Работаем только с надёжными, проверенными специалистами по недвижимости.",

  // Snackbar messages
  welcomeUserSnackbar:
    "Добро пожаловать! Функции панели управления скоро появятся.",
  welcomeAdminSnackbar: "С возвращением, администратор!",

  // Dashboard
  dashboardWelcome: "С возвращением",
  dashboardSubtitle: "Управляйте поиском квартир и сохранёнными объявлениями.",
  dashboardSearch: "Поиск",
  dashboardSearchDesc: "Найти квартиры в Токио",
  dashboardFavorites: "Избранное",
  dashboardFavoritesDesc: "Просмотр сохранённых объявлений",
  dashboardNotifications: "Уведомления",
  dashboardNotificationsDesc: "Обновления по вашим поискам",
  dashboardSettings: "Настройки",
  dashboardSettingsDesc: "Управление аккаунтом",
  dashboardComingSoon: "Функции в разработке",
  dashboardComingSoonDesc:
    "Эти функции сейчас в разработке. Скоро будут доступны!",
  dashboardDevTools: "Инструменты разработчика",
  dashboardDevToolsDesc: "Доступ к API для тестирования и разработки",
  dashboardTokenInfo: "Используйте ID-токен для аутентификации API-запросов в",
  dashboardShowToken: "Показать токен",
  dashboardCopyToken: "Копировать токен",
  dashboardCopied: "Скопировано!",
  dashboardTokenError: "Не удалось получить токен. Обновите страницу.",

  // Overview Page
  back: "Назад",
  overviewSearchingIn: "Поиск в",
  overviewListView: "Список",
  overviewMapView: "Карта",
  overviewResultsTitle: "Результаты поиска",
  overviewNoResults: "Найдено 0 квартир",
  overviewEmptyTitle: "Квартиры не найдены",
  overviewEmptyDesc:
    "Измените фильтры или условия поиска. Данные будут добавлены в ближайшее время.",
  overviewMapTitle: "Просмотр на карте",
  overviewMapComingSoon: "Карта скоро появится",
  overviewMapComingSoonDesc:
    "Интерактивная карта с расположением квартир станет доступна в будущем обновлении.",
  overviewLoading: "Поиск квартир...",
  overviewResults: "квартир найдено",
  overviewErrorTitle: "Что-то пошло не так",
  overviewRetry: "Повторить",
  overviewLoadingMore: "Загрузка...",
  overviewLoadMore: "Загрузить ещё",

  // Listing Card
  "listings.min": "мин",
  "listings.month": "мес",
  "listings.foreignerFriendly": "Иностр. OK",
  "listings.petsAllowed": "Питомцы OK",
  "listings.airConditioning": "Кондиц.",
  "listings.deposit": "Депозит",
  "listings.keyMoney": "Ключ.",

  // Filters
  filtersTitle: "Фильтры",
  filterReset: "Сбросить",

  // Filter Categories
  filterCategoryProperty: "Тип недвижимости",
  filterCategoryPrice: "Цена и сборы",
  filterCategorySize: "Размер и планировка",
  filterCategoryAmenities: "Удобства",
  filterCategoryBuilding: "Здание",
  filterCategoryAccess: "Транспорт",
  filterCategoryContract: "Условия договора",

  // Property Types
  filterPropertyType: "Тип недвижимости",
  filterPropertyApartment: "Апартаменты",
  filterPropertyMansion: "Мансион",
  filterPropertyShareHouse: "Шеа-хаус",
  filterPropertyGuestHouse: "Гестхаус",
  filterPropertyMonthlyMansion: "Помесячный мансион",

  // Room Layouts
  filterRoomLayout: "Планировка",
  filterLayout1R: "1R",
  filterLayout1K: "1K",
  filterLayout1DK: "1DK",
  filterLayout1LDK: "1LDK",
  filterLayout2K: "2K",
  filterLayout2DK: "2DK",
  filterLayout2LDK: "2LDK",
  filterLayout3K: "3K",
  filterLayout3DK: "3DK",
  filterLayout3LDKPlus: "3LDK+",

  // Price Filters
  filterMinRent: "Мин. аренда",
  filterMaxRent: "Макс. аренда",
  filterIncludeManagementFee: "Включая коммунальные",
  filterKeyMoney: "Ключевые деньги",
  filterDeposit: "Депозит",
  filterGuarantor: "Нужен гарант",
  filterNoKeyMoney: "Без ключевых денег",
  filterNoDeposit: "Без депозита",
  filterHalfMonth: "0.5 месяца",
  filter1Month: "1 месяц",
  filter2Months: "2 месяца",
  filterAny: "Любой",
  filterYes: "Да",
  filterNo: "Нет",

  // Size Filters
  filterMinSize: "Мин. площадь",
  filterMaxSize: "Макс. площадь",

  // Amenities
  filterAirConditioning: "Кондиционер",
  filterWasherHookup: "Подключение стиралки",
  filterWasherDryerInUnit: "Стиралка/сушилка в квартире",
  filterBathToiletSeparate: "Раздельный санузел",
  filterBalcony: "Балкон",
  filterFlooringWood: "Деревянный пол",
  filterInternetIncluded: "Интернет включён",
  filterGasStove: "Газовая плита",
  filterIHCooktop: "IH-плита",

  // Building
  filterBuildingAge: "Возраст здания",
  filterAnyAge: "Любой",
  filterUnder5Years: "До 5 лет",
  filterUnder10Years: "До 10 лет",
  filterUnder20Years: "До 20 лет",
  filterUnder30Years: "До 30 лет",
  filterFloor: "Этаж",
  filterAnyFloor: "Любой",
  filterFirstFloor: "1-й этаж",
  filter2ndFloorPlus: "2-й этаж+",
  filter3rdFloorPlus: "3-й этаж+",
  filterTopFloor: "Последний этаж",
  filterElevator: "Лифт",
  filterAutoLock: "Автозамок",
  filterDeliveryBox: "Постамат",
  filterParking: "Есть парковка",
  filterBicycleParking: "Велопарковка",

  // Access
  filterWalkToStation: "До станции пешком",
  filterAnyWalkTime: "Любое расстояние",
  filterWithin5Min: "До 5 мин",
  filterWithin10Min: "До 10 мин",
  filterWithin15Min: "До 15 мин",
  filterWithin20Min: "До 20 мин",

  // New categories
  filterCategoryBathroom: "Ванная и стирка",
  filterCategoryKitchen: "Кухня",
  filterCategorySecurity: "Безопасность",
  filterCategoryListing: "Объявление",

  // Bathroom & Laundry
  filterIndoorWasherSpace: "Место для стиральной машины",
  filterReheatingBath: "Подогрев ванны",
  filterBathroomDryer: "Сушилка в ванной",
  filterWashletSeat: "Биде-сиденье",
  filterIndependentVanity: "Отдельная раковина",

  // Kitchen
  filterSystemKitchen: "Системная кухня",
  filterCounterKitchen: "Кухня с барной стойкой",
  filterDishwasher: "Посудомоечная машина",

  // Building extras
  filterSouthFacing: "Южная сторона",
  filterCornerUnit: "Угловая квартира",
  filterBuildingStructure: "Конструкция здания",
  filterStructureRC: "Железобетон",
  filterStructureSteel: "Стальной каркас",
  filterStructureWood: "Дерево",
  filterStructureSRC: "Стальной железобетон",

  // Security
  filterSecurityCamera: "Камера наблюдения",
  filterVideoIntercom: "Видеодомофон",

  // Parking extras
  filterMotorcycleParking: "Парковка для мотоцикла",

  // Contract
  filterForeignerFriendly: "Для иностранцев",
  filterPetsAllowed: "Животные разрешены",
  filterInstrumentsOK: "Музыкальные инструменты",
  filterSohoOK: "Офис/SOHO",
  filterNoGuarantorNeeded: "Без поручителя",
  filterMoveInWithin30Days: "Заезд в течение 30 дней",

  // Listing freshness
  filterListingFreshness: "Дата публикации",
  filterFreshnessAny: "Любое время",
  filterFreshness24h: "За последние 24 часа",
  filterFreshness3d: "За последние 3 дня",
  filterFreshness7d: "За последние 7 дней",
  filterFreshness14d: "За последние 14 дней",

  // Theme switcher
  themeSwitchToLight: "Переключить на светлую тему",
  themeSwitchToDark: "Переключить на тёмную тему",
};

export const t = (key: keyof Locale, ...args: string[]) =>
  translate(ru, key, ...args);
